import { ConfigActionType } from '@/types';
export const setAppConfig = (payload) => ({
    payload,
    type: ConfigActionType.SET_APP_CONFIG
});
